import './App.css';
// import Footer from './components/Footer';
// import Header from './components/Header';
import Navigation from './Navigation';

function App() {
  return (
    <>
      <div className='w-full h-full mt-0 pt-0 '>
       
        <Navigation />
        
      </div>
    </>
  );
}

export default App;
